import { SGeneralForms } from 'shj-components'
import { useEffect, useMemo, useRef } from 'react'
import { Cascader, message } from 'antd'
import { cloneDeep, isEmpty } from 'lodash-es'
import { businessDictSave, businessDictUpdateById } from '@/services/product.ts'
import { httpOrgList } from '@/services/homeService.ts'
import { getParentId } from '@/utils/common.ts'
import { deleteObjNodeById, trimStr } from '@/utils/data.ts'

const AddOrEditConfigure = props => {
  const { editRef, tree, record } = props
  const formRef = useRef<any>()

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    if (!isEmpty(record)) {
      const idPath = getParentId(tree, record.parentId)
      onFormRef().setFieldsValue({ ...record, parentId: idPath?.reverse() })
    }
    return () => {
      onFormRef()?.resetFields()
    }
  }, [record])

  const newTreeData = useMemo(() => {
    const data = cloneDeep(tree)
    if (record.id && !isEmpty(data)) {
      deleteObjNodeById(data, record.parentId, record.id)
    }
    return data
  }, [tree, record.id])

  const getOptions = async () => {
    let companyList: any = await httpOrgList()
    return Promise.resolve({ companyList: [{ name: '通用', id: '0' }, ...companyList] })
  }

  const onFinish = () => {
    onFormRef()
      .validateFields()
      .then(values => {
        props.setLoading?.(true)
        const apiUrl = values.id ? businessDictUpdateById : businessDictSave
        const newValues = {
          ...values,
          parentId: values.parentId ? values.parentId[values.parentId.length - 1] : '0',
        }
        apiUrl({ data: newValues })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            props.fn?.()
          })
          .finally(() => props.setLoading?.(false))
      })
  }

  if (editRef) editRef.onFinish = onFinish

  const initFlag = record.initFlag
  return (
    <>
      <SGeneralForms
        ref={formRef}
        layout={'vertical'}
        initialValues={{ enabled: true }}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { name: 'id', hidden: true },
              {
                spanCol: 24,
                label: '父级',
                name: 'parentId',
                children: (
                  <Cascader
                    disabled={props.record.initFlag}
                    changeOnSelect
                    options={newTreeData}
                    // expandTrigger={'hover'}
                    displayRender={(labels: string[]) => labels[labels.length - 1]}
                    fieldNames={{ value: 'id' }}
                    placeholder={'请选择父级'}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '字典名称',
                name: 'name',
                required: true,
                rules: [{ required: true, message: '字典名称不能为空' }],
                comConfig: {
                  showCount: true,
                  maxLength: 100,
                  onChange: e => onFormRef()?.setFieldValue('name', trimStr(e.target.value)),
                },
              },
              {
                spanCol: 24,
                label: '值',
                name: 'dataValue',
              },
              {
                spanCol: 24,
                label: '扩展字段',
                name: 'extFirstField',
              },
              {
                spanCol: 24,
                label: '编码',
                name: 'priKey',
                comConfig: { disabled: !!record?.id },
                required: true,
                rules: [{ required: true, message: '编码不能为空' }],
              },
              {
                spanCol: 24,
                label: '排序',
                name: 'sortNumber',
                type: 'inputNumber',
              },
              {
                spanCol: 24,
                label: '状态',
                name: 'enabled',
                type: 'switch',
                comConfig: { disabled: initFlag },
              },
              {
                spanCol: 24,
                label: '描述',
                name: 'description',
                type: 'textarea',
                comConfig: {
                  showCount: true,
                  maxLength: 200,
                },
              },
            ],
          },
        ]}
      />
    </>
  )
}

export default AddOrEditConfigure
